// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"Purchase_breadCrumbs__RILe2","container":"Purchase_container__t83_Z","title":"Purchase_title__PEbcD"};